import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=2cbe16bc&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cbe16bc')) {
      api.createRecord('2cbe16bc', component.options)
    } else {
      api.reload('2cbe16bc', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=2cbe16bc&", function () {
      api.rerender('2cbe16bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wo5Q3uq8zrpG/JS/imageCarousel.vue"
export default component.exports